import {isHandpaintDot,normalizeDotSize,normalizeDotPattern,patternDotPoints,transformedDotPoint} from './dot-pattern.js';

const visible=layer=>layer&&layer.visible!==false&&layer.opacity!==0;
const transformStrokeDot=(layer,point)=>{
 const angle=(layer.rotation||0)*Math.PI/180,scale=layer.scale||1,dx=(point.x-50)*scale,dy=(point.y-75)*scale;
 return{x:layer.x+dx*Math.cos(angle)-dy*Math.sin(angle),y:layer.y+dx*Math.sin(angle)+dy*Math.cos(angle)};
};
export function dotSelectionDetails(nail,selection) {
 const layer=nail?.layers?.find(item=>item.id===selection?.layerId);
 if(!visible(layer))return null;
 if(isHandpaintDot(layer)){
  const size=normalizeDotSize(layer.strokeWidth),point=transformStrokeDot(layer,layer.points[0]);
  return{layerId:layer.id,dotId:null,size,...point,r:size*(layer.scale||1)/2};
 }
 if(layer.kind!=='pattern'||layer.type!=='dots'||!selection.dotId)return null;
 const point=patternDotPoints(layer).find(dot=>dot.id===selection.dotId);
 if(!point)return null;
 return{layerId:layer.id,dotId:point.id,size:point.r*2,...transformedDotPoint(layer,point),r:point.r*(layer.scale||1)};
}

// Pick within the actual painted circle. A grid's empty space continues to drag
// its complete layer; a dot edit never turns a repeated dot into a billable layer.
export function dotAtLayer(layer,point) {
 if(!visible(layer)||!point||![point.x,point.y].every(Number.isFinite))return null;
 if(isHandpaintDot(layer)){
  const dot=dotSelectionDetails({layers:[layer]},{layerId:layer.id});
  return Math.hypot(point.x-dot.x,point.y-dot.y)<=dot.r?{layerId:layer.id,dotId:null}:null;
 }
 if(layer.kind!=='pattern'||layer.type!=='dots')return null;
 let selected=null,distance=Infinity;
 for(const dot of patternDotPoints(layer)){
  const p=transformedDotPoint(layer,dot),delta=Math.hypot(point.x-p.x,point.y-p.y);
  if(delta<=dot.r*(layer.scale||1)&&delta<distance){distance=delta;selected={layerId:layer.id,dotId:dot.id};}
 }
 return selected;
}

export function resizeSelectedDot(nail,selection,value) {
 const selected=dotSelectionDetails(nail,selection),size=normalizeDotSize(value);
 if(!selected||size===selected.size)return nail;
 return{...nail,layers:nail.layers.map(layer=>{
  if(layer.id!==selected.layerId)return layer;
  if(selected.dotId===null)return{...layer,strokeWidth:size};
  const state=normalizeDotPattern(layer),dotSizes={...state.dotSizes,[selected.dotId]:size};
  if(size===state.dotSize)delete dotSizes[selected.dotId];
  const next={...layer,dotSizes};if(!Object.keys(dotSizes).length)delete next.dotSizes;
  return next;
 })};
}
